import { regex } from 'react-admin'

const validateTypebotPublicId = regex(
  /^(?!-)(?!.*--)[a-z0-9-]+$/,
  'Use lowercase letters, numbers and single dashes, not starting with a dash'
)

export default validateTypebotPublicId
